<template>
  <v-card class="ma-2 card-rounded" flat>
    <v-tabs style="border-radius: 10px 10px 0 0" show-arrows icons-and-text>
      <v-tabs-slider></v-tabs-slider>
      <v-tab @click="onChangeTab(true)" href="#tab-1">
        Act. Clínicas
        <Icon class="mb-1" name="clipboard" />
      </v-tab>
      <v-tab-item value="tab-1">
        <v-divider />
        <LogbookTable
          :coordinatedUsers="coordinatedUsers"
          :selectedUsers="selectedUsers"
        />
      </v-tab-item>

      <v-tab @click="onChangeTab(false)" href="#tab-2">
        Act. Científica
        <Icon class="mb-1" name="cientific" />
      </v-tab>
      <v-tab-item value="tab-2">
        <v-divider />
        <ScientificActivityTable :coordinatedUser="coordinatedUser" />
      </v-tab-item>

      <v-tab @click="onChangeTab(false)" href="#tab-3">
        Act. Formativa
        <Icon class="mb-1" name="certific" />
      </v-tab>
      <v-tab-item value="tab-3">
        <v-divider />
        <TrainningActivityTable :coordinatedUser="coordinatedUser" />
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>

<script>
import LogbookTable from './LogbookTable.vue'
import ScientificActivityTable from './ScientificActivityTable.vue'
import TrainningActivityTable from './TrainningActivityTable.vue'
export default {
  components: {
    LogbookTable,
    ScientificActivityTable,
    TrainningActivityTable
  },
  props: {
    coordinatedUser: {
      type: String
    },
    CoordinationComponent: {
      type: Array
    },
    onChangeTab: {
      type: Function
    },
    selectedUsers: {
      type: Array
    },
    coordinatedUsers: {
      type: Array
    }
  }
}
</script>
